module.exports = __webpack_public_path__ + "static/media/age_rating_16.f63169ea.svg";